import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
// ENG-278 — demo roles + email sign-in are commented out (not deleted) so they
// can be restored after the ArduPilot conference. Keycloak is the only sign-in.
// import { LOGIN_ROLES, type LoginRole, ROLE_LABEL } from '@/lib/auth/access';
import { loginWithKeycloak } from '@/lib/auth/keycloak';
import { config } from '@/lib/config';
// import { mockUserForRole, useAuthStore } from '@/lib/store/auth';
import { VERSION_LABEL } from '@/lib/version';
// import { useState } from 'react';
// import { toast } from 'sonner';

// const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function LoginModal({
  open,
  onOpenChange,
}: { open: boolean; onOpenChange: (o: boolean) => void }) {
  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  // // Mock role picker — stands in for Keycloak-derived claims until 86e232ykg
  // // wires real OIDC. Defaults to admin so the full surface is reachable in demos.
  // const [role, setRole] = useState<LoginRole>('admin');
  // const [error, setError] = useState<string | null>(null);
  // const [loading, setLoading] = useState(false);
  // const setUser = useAuthStore((s) => s.setUser);

  // const submit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setError(null);
  //   setLoading(true);
  //   await new Promise((r) => setTimeout(r, 600)); // simulated round-trip
  //   if (!EMAIL_RE.test(email) || !password) {
  //     setError('Enter a valid email and password.');
  //     setLoading(false);
  //     return;
  //   }
  //   setUser({ ...mockUserForRole(role), email });
  //   toast.success(`Signed in as ${ROLE_LABEL[role]}`);
  //   onOpenChange(false);
  //   setLoading(false);
  // };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Sign in to FLYsafe</DialogTitle>
          <DialogDescription>RPAS Traffic Management (RTM) Platform</DialogDescription>
        </DialogHeader>
        {config.features.keycloakAuth ? (
          <Button onClick={() => loginWithKeycloak()}>Sign in with {config.tenant.label}</Button>
        ) : (
          <div className="text-[0.769em] text-(--color-text3) text-center">
            Sign-in is not configured for this deployment.
          </div>
        )}
        {/*
        {config.features.keycloakAuth && (
          <div className="flex items-center gap-2 my-1">
            <div className="h-px flex-1 bg-(--color-border)" />
            <span className="text-[0.615em] text-(--color-text3) uppercase tracking-wider">
              or use a demo role
            </span>
            <div className="h-px flex-1 bg-(--color-border)" />
          </div>
        )}
        <div>
          <div className="text-[0.615em] font-bold uppercase tracking-wider text-(--color-text3) mb-1">
            Sign in as (demo role)
          </div>
          <div className="flex gap-1.5">
            {LOGIN_ROLES.map((r) => (
              <Button
                key={r}
                type="button"
                size="xs"
                variant="toggle"
                data-on={role === r}
                onClick={() => setRole(r)}
                className="flex-1"
              >
                {ROLE_LABEL[r]}
              </Button>
            ))}
          </div>
        </div>
        <Button
          variant="outline"
          onClick={() => {
            setUser(mockUserForRole(role));
            toast.success(`Signed in with Google as ${ROLE_LABEL[role]}`);
            onOpenChange(false);
          }}
        >
          Continue with Google
        </Button>
        <div className="flex items-center gap-2 my-1">
          <div className="h-px flex-1 bg-(--color-border)" />
          <span className="text-[0.615em] text-(--color-text3) uppercase tracking-wider">or</span>
          <div className="h-px flex-1 bg-(--color-border)" />
        </div>
        <form onSubmit={submit} noValidate className="space-y-2">
          <Field label="Email">
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-2 h-8 rounded-md border border-(--color-border) bg-(--color-surface) text-[0.846em] outline-none focus:border-(--color-green)"
              placeholder="you@airmarket.io"
            />
          </Field>
          <Field label="Password">
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-2 h-8 rounded-md border border-(--color-border) bg-(--color-surface) text-[0.846em] outline-none focus:border-(--color-green)"
            />
          </Field>
          {error && <div className="text-[0.769em] text-(--color-red)">{error}</div>}
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </Button>
        </form>
        */}
        <div className="text-[0.692em] text-(--color-text3) text-center mt-1">
          Don't have an account? <b className="text-(--color-text2)">Contact your administrator</b>
        </div>
        {/* The only place the build is visible when a user *can't* sign in —
            which is exactly when they file the report. */}
        <div className="text-[0.615em] font-mono text-(--color-text3) text-center">
          {VERSION_LABEL} · {config.tenant.id}
        </div>
      </DialogContent>
    </Dialog>
  );
}

// function Field({ label, children }: { label: string; children: React.ReactNode }) {
//   return (
//     <label className="block">
//       <span className="block text-[0.615em] font-bold uppercase tracking-wider text-(--color-text3) mb-1">
//         {label}
//       </span>
//       {children}
//     </label>
//   );
// }
